
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorHandler } from 'utilities/error';
import { DataHandler } from 'utilities/data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  withCredentials: true
};

@Injectable()
export class SourceTableJoinConditionService {
    private apiPath = 'api/EDWSourceTableJoinCondition';
    private requestUrl = environment.serviceUrl + this.apiPath

    constructor(private http: HttpClient) { }

    /**
     * Deletes SourceTableJoinCondition by Id
     * @param Id Join Condition id
     * @author Nash Lindley
     */
    deleteJoinConditions(Id) {
        return this.http.delete(`${this.requestUrl}?Id=${+Id}`, httpOptions).pipe(
            catchError(new ErrorHandler().handleError));
    }

}
